module.exports = __webpack_public_path__ + "937403bd2b805454ec22ef05ace9180d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-420.webp.png
// module id = 294
// module chunks = 0